import { render, staticRenderFns } from "./groupBuying.vue?vue&type=template&id=52328899&"
import script from "./groupBuying.vue?vue&type=script&lang=js&"
export * from "./groupBuying.vue?vue&type=script&lang=js&"
import style0 from "./groupBuying.vue?vue&type=style&index=0&id=52328899&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports